var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExploreTalentsOnDemand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 197.19,
    height: 222.74,
    viewBox: "0 0 197.19 222.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11373",
    "data-name": "Path 11373",
    d: "M111.931,53.152V97.266a11.461,11.461,0,0,1-11.463,11.462H56.352A11.464,11.464,0,0,1,44.89,97.266V53.152A11.464,11.464,0,0,1,56.352,41.688h44.116a11.464,11.464,0,0,1,11.463,11.464",
    transform: "translate(-44.89 -41.688)",
    fill: "#d2e4ff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2021",
    "data-name": "Rectangle 2021",
    width: 156.973,
    height: 207.35,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2019",
    "data-name": "Rectangle 2019",
    width: 74.901,
    height: 74.477,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22196",
    "data-name": "Group 22196",
    transform: "translate(-831.852 -182.063)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11341",
    "data-name": "Path 11341",
    d: "M152.018,352.337c0,4.264-34.03,7.72-76.009,7.72S0,356.6,0,352.337s34.03-7.721,76.009-7.721,76.009,3.457,76.009,7.721",
    transform: "translate(877.023 44.746)",
    fill: "#7586ec",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22195",
    "data-name": "Group 22195",
    transform: "translate(831.852 182.063)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11363",
    "data-name": "Path 11363",
    d: "M74.894,90.341H15.448A15.448,15.448,0,0,1,0,74.894V15.448A15.448,15.448,0,0,1,15.448,0H74.894A15.447,15.447,0,0,1,90.341,15.448V74.894A15.447,15.447,0,0,1,74.894,90.341",
    transform: "translate(0 0)",
    fill: "#d2e4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11364",
    "data-name": "Path 11364",
    d: "M111.931,53.152V97.266a11.461,11.461,0,0,1-11.463,11.462H56.352A11.464,11.464,0,0,1,44.89,97.266V53.152A11.464,11.464,0,0,1,56.352,41.688h44.116a11.464,11.464,0,0,1,11.463,11.464",
    transform: "translate(-33.29 -30.915)",
    fill: "#d2e4ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2022",
    "data-name": "Rectangle 2022",
    width: 90.341,
    height: 90.341,
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22194",
    "data-name": "Group 22194",
    transform: "translate(11.652 11.031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_7",
    "data-name": "Mask Group 7",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22193",
    "data-name": "Group 22193",
    transform: "translate(-2.799 8.503)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11365",
    "data-name": "Path 11365",
    d: "M87.415,93.97a.791.791,0,0,0-.019-.1c-.141-.8-.3-1.6-.475-2.377v0c.975-6.266-1.43-8.944-3.511-10.3h0C82.292,79,81.1,77.461,79.965,76.938a11.109,11.109,0,0,0-6.084-.641,2.8,2.8,0,0,1,1.211-.705,9.3,9.3,0,0,0-3.238,1.143c-14.719-4.292-15.19,16.887-14.48,21.738s-4.244,6.872-11.338,11.34c-6.445,4.059-9.915,8.436-11.782,11.906a11.243,11.243,0,0,0,.554,3.14,2.212,2.212,0,0,1,.7-.452c-.014.043-.191.521-.425,1.195a11.457,11.457,0,0,0,9.318,7.1l8.023.925,1.541.179,12.006,1.385c1.261-1.788,2.634-3.638,4.061-5.474A119.511,119.511,0,0,1,80.6,117.647c1.089-1.056,2.124-1.979,3.076-2.734l.106-.083a13.9,13.9,0,0,0,1.135-2.759,33.691,33.691,0,0,0,1.224-7.386,32.7,32.7,0,0,1-.692,7.459,13.074,13.074,0,0,1-.5,1.641,8.939,8.939,0,0,0,1.126-1.543c2.5-4.288,2.533-11.479,1.336-18.272",
    transform: "translate(-34.254 -75.589)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11366",
    "data-name": "Path 11366",
    d: "M179.711,188.6c.045.027-4.845,1.89-8.206.541-3.161-1.267-4.806-5.745-4.76-5.749,1.414-.116,2.032-1.969,2.944-10.135l.611.2,10.267,3.292s-.62,3.279-.987,6.393c-.309,2.615-.436,5.114.131,5.463",
    transform: "translate(-132.506 -148.018)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11367",
    "data-name": "Path 11367",
    d: "M166.36,89.148s4.733-5.974,11.7-1.272c0,0-3.854-.337-11.7,1.272",
    transform: "translate(-132.221 -83.363)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11368",
    "data-name": "Path 11368",
    d: "M190.771,177.305s-.62,3.279-.987,6.393c-5.861-.843-8.35-6.566-9.281-9.686Z",
    transform: "translate(-142.71 -148.578)",
    fill: "#ef9e67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11369",
    "data-name": "Path 11369",
    d: "M182.126,127.427s-13.935,1.406-14.677-7.285-3.041-14.364,5.825-15.629,10.88,1.9,11.833,4.744.625,17.58-2.981,18.17",
    transform: "translate(-132.417 -96.826)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11370",
    "data-name": "Path 11370",
    d: "M167.78,98.142s-2.961,10.52-8.7,12.522-8.412.645-8.412.645a16.663,16.663,0,0,0,4.6-10.268s9.215-7.511,12.506-2.9",
    transform: "translate(-120.586 -91.204)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11371",
    "data-name": "Path 11371",
    d: "M213.484,100.559s3.045,2.036,3.928,4.191,1.579,6.685,2.894,6.418c0,0,2.294-7.174-1.271-10.822-3.781-3.868-5.551.213-5.551.213",
    transform: "translate(-167.167 -92.714)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11372",
    "data-name": "Path 11372",
    d: "M145.519,214.793c-1.448-1.815-4.406-2.759-7.307-3.246-.212-.033-.421-.066-.631-.1-.179-.025-.355-.05-.531-.073-1.224-.16-2.4-.242-3.4-.286-.149-.211-.241-.342-.267-.382a.064.064,0,0,1-.011-.012l-11.784-.954-.124-.011-.023,0-.027,0c-.888-.1-13.095-1.307-15.455,3-1.543,2.815-1.574,8.2-.844,14.175-.22,2.027-.4,4.089-.564,6.026l1.541.178,12.006,1.385,3.673.423,18.579,2.143a11.21,11.21,0,0,0,1.23.075h0a11.366,11.366,0,0,0,4.256-.786,11.49,11.49,0,0,0,5.6-4.69v0c-1.786-7.314-4.022-14.474-5.924-16.862",
    transform: "translate(-86.385 -174.895)",
    fill: "#699dee"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22192",
    "data-name": "Group 22192",
    transform: "translate(836.998 189.733)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22191",
    "data-name": "Group 22191",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22190",
    "data-name": "Group 22190"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22189",
    "data-name": "Group 22189",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11342",
    "data-name": "Path 11342",
    d: "M303.715,170.107s-.719-1.606-1.184-2.367-2.453-2.989-2.791-2.485-1.692,3.9-.973,4.852-.047,2.605,3.529,3.607Z",
    transform: "translate(-219.176 -121.51)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11343",
    "data-name": "Path 11343",
    d: "M353.361,145.447s-18.3,15.191-25.439,13.785a141.419,141.419,0,0,1-14.145-4.02l-1.713,4.356s7.681,10.36,15.689,10.428a45.811,45.811,0,0,0,21.764-5.388Z",
    transform: "translate(-229.089 -106.993)",
    fill: "#262d4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11344",
    "data-name": "Path 11344",
    d: "M529.968,743.88s-.531,8.522-2.19,8.644c-.22.016-8.41.016-8.41.016l-10.454-.06a3.379,3.379,0,0,1,3.124-3.034c3.056-.53,8.171-2.665,10.022-6.681,1.947-4.225,7.908,1.115,7.908,1.115",
    transform: "translate(-373.598 -545.191)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11345",
    "data-name": "Path 11345",
    d: "M492.44,461.006a21.908,21.908,0,0,1-5.659,1.057,20.892,20.892,0,0,1-5.283-.75s-.6-5.754-3.891-18.431c-1.726-6.645-4.191-15.188-7.7-25.8-9.7-29.34-12.646-46.5-12.915-48.129-.014-.086-.02-.128-.02-.128l.032-.015,29.813-13.016s-3.685,40.437,1.016,55.958a65.081,65.081,0,0,1,1.706,7.436c2.969,16.859,2.9,41.821,2.9,41.821",
    transform: "translate(-335.467 -261.725)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11346",
    "data-name": "Path 11346",
    d: "M477.663,442.884c-1.726-6.645-4.192-15.188-7.7-25.8-9.7-29.34-12.646-46.5-12.915-48.129,0-.048.006-.094.011-.142l29.813-13.016s-3.685,40.437,1.016,55.958c.659,2.169-10.227,31.133-10.227,31.133",
    transform: "translate(-335.523 -261.726)",
    fill: "#6392dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11347",
    "data-name": "Path 11347",
    d: "M442.394,743.88s-.532,8.522-2.19,8.644c-.221.016-8.41.016-8.41.016l-10.454-.06a3.379,3.379,0,0,1,3.124-3.034c3.056-.53,8.171-2.665,10.022-6.681,1.947-4.225,7.908,1.115,7.908,1.115",
    transform: "translate(-309.309 -545.191)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11348",
    "data-name": "Path 11348",
    d: "M436.929,359.4a419.66,419.66,0,0,0,4.172,58.377c4.56,32.173,3.014,45.83,3.014,45.83a31.223,31.223,0,0,0,4.4,1.112,20.058,20.058,0,0,0,6.523-.751s6.526-32.185,4.655-48.289,8.937-55.258,8.937-55.258Z",
    transform: "translate(-320.747 -264.376)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11349",
    "data-name": "Path 11349",
    d: "M482.33,91.425l-5.82,3.794-5.3-1.49c-.969-1.375-1.225-4.024-1.24-6.32a39.057,39.057,0,0,1,.208-4.208l7.852-3.446,2.93-1.284c-.008.045-.228,2.392-.259,2.735a19.834,19.834,0,0,0,1.63,10.218",
    transform: "translate(-345.008 -57.725)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11350",
    "data-name": "Path 11350",
    d: "M436.117,189.953c7.244,6.954,34.657,5.785,36.347-1.877s-1.842-65.223-14.216-68.839c-2.567-.751-16.294,3.661-16.294,3.661a86.187,86.187,0,0,0-3.567,12.736c-.274,1.389-1.074,16.1-1.673,29.86-.279,6.436-.516,12.667-.637,17.228-.11,4.273-.116,7.08.04,7.232",
    transform: "translate(-320.069 -87.649)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11351",
    "data-name": "Path 11351",
    d: "M480.113,84.884c-1.593,2.678-7.182,5.021-10.143,6.1a39.065,39.065,0,0,1,.208-4.208l7.852-3.446c1.736-.023,2.793.363,2.083,1.559",
    transform: "translate(-345.008 -61.295)",
    fill: "#fca56b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11352",
    "data-name": "Path 11352",
    d: "M455.25,36.959s12.651,3.924,14.987-3.947,5.542-12.666-2.436-15.5-10.446-.3-11.869,2.141-3.913,16.086-.682,17.31",
    transform: "translate(-333.041 -11.958)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11353",
    "data-name": "Path 11353",
    d: "M460.767,6.933s.807,9.16,2.712,8.762,4-1.248,3.723,1.513,1.852,7.494,4.6,7.483c5.892-.024,12.293-15.056,10.68-17.906-4.653-8.225-28.44-9.885-21.714.149",
    transform: "translate(-337.379 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11354",
    "data-name": "Path 11354",
    d: "M461.761,109.48c.163-.068,9.418-4.2,10.5-3.841s2.431,3.642,2.431,3.642l-16.3,3.663a8.065,8.065,0,0,1,3.364-3.465",
    transform: "translate(-336.513 -77.694)",
    fill: "#262d4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11355",
    "data-name": "Path 11355",
    d: "M251.327,275.114,303.2,323.681c1.017.952,2.3,1.255,2.85.674l1.751-1.849c.55-.581.169-1.836-.848-2.788l-51.877-48.566c-1.017-.952-2.3-1.255-2.849-.674l-1.751,1.849c-.55.581-.169,1.836.848,2.788",
    transform: "translate(-183.693 -198.749)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11356",
    "data-name": "Path 11356",
    d: "M363.853,380.9l22.765,21.312c1.017.952,2.3,1.255,2.849.674l1.751-1.849c.55-.581.169-1.836-.848-2.788l-22.765-21.312Z",
    transform: "translate(-267.107 -277.277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11357",
    "data-name": "Path 11357",
    d: "M70.272,34.665A40.818,40.818,0,0,0,12.8,32.925c-.217.2-.43.405-.638.612a40.261,40.261,0,0,0-1.117,56.537,40.829,40.829,0,0,0,57.477,1.743,40.261,40.261,0,0,0,1.75-57.152m-3.95,54.828a37.584,37.584,0,0,1-52.937-1.607A37.222,37.222,0,0,1,34.241,25.679,37.536,37.536,0,0,1,67.935,36.853a37.089,37.089,0,0,1-1.613,52.64",
    transform: "translate(0 -16.14)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22188",
    "data-name": "Group 22188",
    transform: "translate(3.21 8.993)",
    opacity: 0.28
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22187",
    "data-name": "Group 22187"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22186",
    "data-name": "Group 22186",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11358",
    "data-name": "Path 11358",
    d: "M22.248,96.767A37.22,37.22,0,1,0,23.862,44.13a37.346,37.346,0,0,0-1.614,52.638",
    transform: "translate(-12.074 -34.014)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_11359",
    "data-name": "Path 11359",
    d: "M436.3,228.048c28.585-20.253,26.208-47.28,26.208-47.28-10.448,5.859-20.815,18.814-25.571,30.052-.279,6.436-.516,12.666-.637,17.228",
    transform: "translate(-320.29 -132.975)",
    fill: "#262d4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11360",
    "data-name": "Path 11360",
    d: "M307.523,318.471a7.808,7.808,0,0,1-3.651-2.243s-.86.058.141,1.882c.084.153.27.544.41.821a.177.177,0,0,1-.15.255c-1.163.088-2.332-.37-4.573.095-.309.064-.4.8-.387,1.114a2.83,2.83,0,0,0,.6,1.941c.361.474,1.369.983,3.612,1.881.855.342,3.3.084,5.589-.7l1.83-.843-.568-3.382-.46.1c-.73.153-1.634-.734-2.4-.92",
    transform: "translate(-219.727 -232.621)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11361",
    "data-name": "Path 11361",
    d: "M381.529,133.331s25.684,4.863-7.556,41.845c-5.316,5.915-34.038,13.616-34.038,13.616s-2.913-2.464-1.445-4.46c0,0,19.776-14.279,24.127-16.549,1.957-1.022,7.6-22.792,10.788-28.035a14.383,14.383,0,0,1,8.124-6.417",
    transform: "translate(-248.184 -98.08)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11362",
    "data-name": "Path 11362",
    d: "M305.712,168.189a12.948,12.948,0,0,1-1-2.438,13.448,13.448,0,0,0-1.658-3.73c-.175-.173-.75.051-.818.8a4.31,4.31,0,0,0,.413,1.615,18.1,18.1,0,0,1,.544,3.21c.4,1.287,2.523.549,2.523.549",
    transform: "translate(-221.868 -119.143)",
    fill: "#ffb27d"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreTalentsOnDemand);
export default __webpack_public_path__ + "static/media/explore-talents-on-demand.dbe08d5b74ca4b8eef651516b84bd9ff.svg";
export { ForwardRef as ReactComponent };